export enum AccountType {
    UserAccount = "UserAccount",
    ResourceAccount = "ResourceAccount"
}
